import React, { useRef, useState, useEffect } from 'react';

import { Tooltip } from '@vlabs/uikit';
import cn from 'classnames';
import PropTypes from 'prop-types';

import st from './TruncatedText.module.sass';

// FIXME странный комопонент, вроде из названия следует, что он обрезает текст, но у него есть проп hasTruncation..
export function TruncatedText({
  children,
  tooltipContent,
  hasTruncation = false,
  position = 'bottom',
  lineClamp = 1,
  ...props
}) {
  const [isTruncated, setIsTruncated] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;

    const measure = () => {
      const isOverflowing = lineClamp > 1
        ? el.scrollHeight > el.clientHeight
        : el.scrollWidth > el.clientWidth;
      setIsTruncated(isOverflowing);
    };
    const ro = new ResizeObserver(measure);

    ro.observe(el);
    measure();

    return () => ro.disconnect();
  }, [children, tooltipContent, hasTruncation, lineClamp]);

  return (
    <Tooltip
      className={st.TooltipWrapper}
      position={position}
      tooltipContent={tooltipContent}
      tooltipProps={{ hidden: !hasTruncation || !isTruncated }}
      {...props}
    >
      <div
        className={cn(
          st.Content,
          {
            [st.Content_truncated]: hasTruncation,
            [st.Content_lineClamp]: lineClamp > 1,
          },
        )}
        ref={ref}
        style={lineClamp > 1
          ? {
            display: '-webkit-box',
            WebkitLineClamp: lineClamp,
          }
          : undefined}
      >
        {children}
      </div>
    </Tooltip>
  );
}

TruncatedText.propTypes = {
  children: PropTypes.node.isRequired,
  tooltipContent: PropTypes.string.isRequired,
  hasTruncation: PropTypes.bool,
  position: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
  lineClamp: PropTypes.number,
};
